var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "whatsapp-channel-detail" } },
    [
      _vm.channel
        ? _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "IconButton",
                    {
                      attrs: {
                        "on-click": function () {
                          return _vm.$router.push("/integrations/whatsapp-v2")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" chevron_left "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [_c("WhatsappIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v("Whatsapp V2 Channel :" + _vm._s(_vm.channel.name)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.channel,
                      expression: "channel",
                    },
                  ],
                  staticClass: "right",
                },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          _vm.visible = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("wp.startChatWithAnyNo")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.refreshChannel },
                    },
                    [_vm._v(" Refresh ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.restartEnabled },
                      on: { click: _vm.restartChannel },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("whatsappChannel.restartChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("whatsappChannel.deleteChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "channel-content" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("SidebarChild", {
                    attrs: {
                      items: _vm.menuItems,
                      "selected-item": _vm.type,
                      focusActive: true,
                    },
                    on: {
                      selected: function (i) {
                        return (_vm.type = i.key)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.channel
                ? _c("div", { staticClass: "page-content" }, [
                    _vm.type === "integration"
                      ? _c(
                          "div",
                          [
                            _c("WhatsappWizard", {
                              attrs: { channel: _vm.channel },
                              on: {
                                complated: function () {
                                  return (_vm.type = "detail")
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "detail"
                      ? _c(
                          "div",
                          [
                            _c("UpdateDetail", {
                              attrs: { "show-visibility-config": false },
                              model: {
                                value: _vm.channel,
                                callback: function ($$v) {
                                  _vm.channel = $$v
                                },
                                expression: "channel",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "visibility"
                      ? _c(
                          "div",
                          [
                            _c("Visibility", {
                              model: {
                                value: _vm.channel,
                                callback: function ($$v) {
                                  _vm.channel = $$v
                                },
                                expression: "channel",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "all-contacts"
                      ? _c(
                          "div",
                          [
                            _c("WhatsappContactList", {
                              attrs: {
                                channel: _vm.channel,
                                "channel-id": _vm.channel._id,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "broadcast-requests"
                      ? _c(
                          "div",
                          [
                            _c("BroadcastRequests", {
                              attrs: {
                                channel: _vm.channel,
                                changePage: _vm.changePage,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "customer-groups"
                      ? _c(
                          "div",
                          [
                            _c("CustomerGroups", {
                              attrs: {
                                channel: _vm.channel,
                                changePage: _vm.changePage,
                                "channel-id": _vm.channel._id,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "wallet"
                      ? _c(
                          "div",
                          { staticStyle: { padding: "10px" } },
                          [_c("Wallet")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "comparison"
                      ? _c(
                          "div",
                          { staticStyle: { padding: "20px" } },
                          [_c("WhatsappComparison")],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("whatsappChannel.whatsappChannel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteWhatsappChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("whatsappChannel.deleteWhatsappChannelDescription"))
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.channel
        ? _c("WhatsappStartChat", {
            attrs: {
              visibleStartChat: _vm.visible,
              "show-alert-message": _vm.showAlertMessage,
              "channel-id": _vm.channel._id,
              channel: _vm.channel,
            },
            on: {
              "modal-closed": function ($event) {
                _vm.visible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }